import { cwslapi } from "../index";

// 获取弹窗图片列表
export const getwebImgListApi = () => {
  return cwslapi({
    url: "/public/getWebImgList",
    method: "get",
    xhrFields: {
            withCredentials: true,
          },
  });
};
